import { render, staticRenderFns } from "./MpDraw13V2.vue?vue&type=template&id=8c6458be&scoped=true&"
import script from "./MpDraw13V2.vue?vue&type=script&lang=js&"
export * from "./MpDraw13V2.vue?vue&type=script&lang=js&"
import style1 from "./MpDraw13V2.vue?vue&type=style&index=1&id=8c6458be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6458be",
  null
  
)

export default component.exports